import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

const DESKTOP_QUERY = "(min-width: 1024px)"; // breakpoint `lg` do Tailwind

/** Estado do drawer mobile (S16): fecha ao navegar e ao passar para o layout desktop (≥ lg). */
export function useMobileSidebar(): [boolean, (open: boolean) => void] {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    setOpen(false);
  }, [pathname]);

  useEffect(() => {
    if (typeof window === "undefined" || !window.matchMedia) return undefined;
    const media = window.matchMedia(DESKTOP_QUERY);
    const onChange = (event: MediaQueryListEvent) => {
      if (event.matches) setOpen(false);
    };
    media.addEventListener("change", onChange);
    return () => media.removeEventListener("change", onChange);
  }, []);

  return [open, setOpen];
}
